// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spoof-warning {
  background-color: black;
  color: white;
  text-align: center;
  font-size: 1.5em; }
`, "",{"version":3,"sources":["webpack://./src/components/SpoofWarning/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB,EAAE","sourcesContent":[".spoof-warning {\n  background-color: black;\n  color: white;\n  text-align: center;\n  font-size: 1.5em; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
